import { cn } from '@my-medication/shared-components/shadcn/utils';
import { type FunctionComponent } from 'react';

import { type LabelValueProps } from './LabelValue.types';

const LabelValue: FunctionComponent<LabelValueProps> = ({ label, children, className, labelClassName }) => (
  <>
    <span className={cn('text-caption-2 text-secondary-700', labelClassName)}>{label}</span>
    <span className={className}>{children}</span>
  </>
);

LabelValue.displayName = 'LabelValue';
export { LabelValue };
